import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

//准备actions 用于相应组件中的动作
const actions = {}
//准备mutations 用于操作数据
const mutations = {
  changePathPlan(state) {
    state.showPathPlan = !state.showPathPlan
  },
  changeEnviromentId(state, id) {
    state.environment = id;
  },
  // changeDraw2DGrid(state) {
  //   state.isDraw2DGrid = !state.isDraw2DGrid
  // },
  // changeDraw3DGrid(state) {
  //   state.isDraw3DGrid = !state.isDraw3DGrid
  // },
  // changeShowLevel(state) {
  //   state.isShowLevel = !state.isShowLevel
  // },
  // changeShowCode(state) {
  //   state.isShowCode = !state.isShowCode
  //   state.isShowDecode = false
  // },
  // changeShowDecode(state) {
  //   state.isShowDecode = !state.isShowDecode
  //   state.isShowCode = false
  // },
  // changeShowCodeTransform(state) {
  //   state.isShowCodeTransform = !state.isShowCodeTransform;
  //   //state.isShowCodeTransform = false;
  // },
  changeShowScenarioList(state) {
    state.isShowScenarioList = !state.isShowScenarioList
  },
  // changeShowSpaceRelation(state) {
  //   state.isShowSpaceRelation = !state.isShowSpaceRelation
  // },
  // changeShowOverAnalysis(state) {
  //   state.isShowOverAnalysis = !state.isShowOverAnalysis
  // },
  // changShowNearGrid2d(state) {
  //   state.isShowNearGrid2d = !state.isShowNearGrid2d
  // },
  // changeShowFather2d(state, value) {
  //   state.isShowFather2d = !state.isShowFather2d
  //   state.componentName = value
  // },
  // changeShowChild2d(state, value) {
  //   state.isShowChild2d = !state.isShowChild2d
  //   state.componentName = value
  // },
  // changeShowFather3d(state, value) {
  //   state.isShowFather3d = !state.isShowFather3d
  //   state.componentName = value
  // },
  // changeShowChild3d(state, value) {
  //   state.isShowChild3d = !state.isShowChild3d
  //   state.componentName = value
  // },
  // changShowNearGrid3d(state, value) {
  //   state.isShowNearGrid3d = !state.isShowNearGrid3d
  //   state.componentName = value
  // },
  // clearComponentName(state) {
  //   state.componentName = ""
  // }
}
//准备state 用于存储数据
const state = {
  colorChange: 1,
  colorActiveIndex: 2, //存储当前网格样式index
  colorConfig: {
    cellPolygonColor: "rgba(6,197,205,0.1)",
    cellLineColor: "rgba(6,197,205,1)",
    clickCellColor: "rgba(6,197,205,0.4)",
    textColor: "rgba(0, 0, 0, 1)",
    lineColor: "rgba(0, 70, 248, 1)",
    pointColor: "rgba(0, 70, 248, 1)",
    polygonColor: "rgba(0, 70, 248, 0.4)",
    lineType: "notdot"
  },


  //存储颜色和线性
  polygonColor: {
    red: 1,
    green: 1,
    blue: 1,
    opacity: 0.1
  },
  lineColor: {
    red: 1,
    green: 1,
    blue: 1,
    opacity: 0.85 //未启用
  },
  lineType: "notdot", //用虚线就用dot
  pannelCollection: {
    count: 0,
    value: undefined,
  },
  componentIsShow: undefined,
  showPathPlan: false,
  environment: '',
  //isDraw2DGrid: false,
  //isDraw3DGrid: false,
  //isShowLevel: false,
  // isShowCode: false,
  // isShowDecode: false,
  // isShowCodeTransform: false,
  isShowScenarioList: false,
  // isShowSpaceRelation: false,
  // isShowOverAnalysis: false,
  // isShowNearGrid2d: false,
  // isShowFather2d: false,
  // isShowChild2d: false,
  // isShowFather3d: false,
  // isShowChild3d: false,
  // isShowNearGrid3d: false,
  //判断当前选种的的是哪一个组件
  //componentName: "",

  isShow: true, //产品功能模块弹出层关闭按钮使用
}
export default new Vuex.Store({
  actions,
  mutations,
  state
});